module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aside content"
  }, [_c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.isMobile ? _vm.image_logo_64 : _vm.image_logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "side-list"
  }, [_vm._l((_vm.sideList.tempControl), function(item) {
    return (_vm.router === 'TEMP' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.sideList.MtempControl), function(item) {
    return (_vm.router === 'MTEMP' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.sideList.allocateWater), function(item) {
    return (_vm.router === 'WATER' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), (_vm.router === 'USER') ? _vm._l((_vm.sideList.user), function(item) {
    return _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-menu"
  }, [(_vm.userInfo.identity === 'CUSTOMER') ? _vm._l((_vm.sideList.bottom), function(item) {
    return ((item.path !== '/user?sider=true' || _vm.router !== 'USER') && item.identity === 'CUSTOMER') ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.identity === 'USER') ? _vm._l((_vm.sideList.bottom), function(item) {
    return (item.identity === 'USER') ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16fa4804"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/pageSide.vue
// module id = 895
// module chunks = 1